import * as yup from 'yup';

const validationFields = {
  email: yup
    .string()
    .email('validations.login.email.invalid')
    .required('validations.login.email.required')
    .max(50, 'validations.login.email.maxLength'),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = {
  email: '',
};



// WEBPACK FOOTER //
// ./src/forms/forgotPasswordForm.js